// extracted by mini-css-extract-plugin
export default {"DraftEditor-root":"editor-DraftEditor-root-3D8cg"};